import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './pages/app/app'
import reportWebVitals from './reportWebVitals'
import consoleEasterEgg from './consoleEasterEgg'

import { BrowserRouter } from 'react-router-dom'

import './lang/i18n'
import './index.scss'

// Initialize console easter egg
consoleEasterEgg()

const rootElement = document.getElementById('root') as HTMLElement

// Check if the app was pre-rendered by react-snap
if (rootElement.hasChildNodes()) {
  // Use hydrateRoot for pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )
} else {
  // Use createRoot for normal rendering
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
